module.exports = __webpack_public_path__ + "img/s8Bg3.8fd02244.jpg";